import { initializeApp } from "firebase/app";
import { getAuth, OAuthProvider } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: "AIzaSyB3YOSSlUeoOdelWNCOmHW1dxjGpkCkuLg",
//   authDomain: "dev4sustainability33753.firebaseapp.com",
//   projectId: "dev4sustainability33753",
//   storageBucket: "dev4sustainability33753.appspot.com",
//   messagingSenderId: "56966951373",
//   appId: "1:56966951373:web:9ad21215844a5db6a8d484",
//   measurementId: "G-L6PDHVT5LK",
// };

const firebaseConfig = {
  apiKey: "AIzaSyCgMAYyFBVx_C-Irkr_tTiCdbByAttFHGc",
  authDomain: "uat4sustainability41810.firebaseapp.com",
  projectId: "uat4sustainability41810",
  storageBucket: "uat4sustainability41810.appspot.com",
  messagingSenderId: "655984039366",
  appId: "1:655984039366:web:3492cf095de299ec47cec7",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

const provider = new OAuthProvider("microsoft.com");

provider.setCustomParameters({
  tenant: "bc0c325b-6efc-4ca8-9e46-11b50fe2aab5",
  prompt: "select_account",
});

export default provider;
